









import { Component, Vue } from "vue-property-decorator";
import Buble from "./Buble.vue";

@Component({
  components: {
    Buble
  }
})
export default class CountDown extends Vue {
  GetHochDateTime(): Date {
    return new Date(2023, 7, 29, 15, 0);
  }

  TwoDigist(t: number): string {
    if (t < 10) {
      return "0" + t;
    }
    return String(t);
  }

  workOn(): void {
    const dNow: Date = new Date();
    const seconds: number = Math.floor(
      (Number(this.GetHochDateTime()) - Number(dNow)) / 1000
    );
    if (seconds > 0) {
      this.vTage = this.TwoDigist(Math.floor(seconds / 3600 / 24));
      this.vStunde = this.TwoDigist(Math.floor((seconds % (3600 * 24)) / 3600));
      this.vMinuten = this.TwoDigist(Math.floor((seconds % 3600) / 60));
      this.vSekunden = this.TwoDigist(seconds % 60);
      setTimeout(this.workOn, 1010 - (Number(dNow) % 1000));
    }
  }

  vTage = "0";
  vStunde = "0";
  vMinuten = "0";
  vSekunden = "0";

  mounted(): void {
    this.workOn();
  }
}
